import React from 'react'
import { Icon } from 'antd'
import { StyledLoader } from './styled'
const Loader = props => (
  <StyledLoader indicator={<Icon type="loading-3-quarters" spin />} />
)
export default Loader
